export default __webpack_public_path__ + "static/media/Pop_Up_mobile.57ba15d4.png";